import { combineLatest, concat, from, merge } from "rxjs";
import { buffer, delay, filter, map, switchMap, take } from "rxjs/operators";
import { selectOutskirtBuildingBundleOnLoad } from "../../../../selectors/selectOutskirtBuildingInfo";
import { utilLoader } from "../../../../utils/loader/utilLoader";
import { TypeActionLoading } from "../../../loading/actionLoading";
import { createLoaderEventToActionMapper } from "../../../loading/createLoaderEventToActionMapper";
import { IdAssetBundleCore } from "../../../loading/IdAssetBundleCore";
import { actionOutskirtsBundleLoad, TypeActionOutskirtsBundle, } from "../actionOutskirtBundleLoad";
import { TypeActionOutskirtsInfo } from "../actionOutskirtsInfo";
export var epicLoadOutskirtBuildings = function (action$, state$, deps) {
    var initBundle$ = combineLatest(action$.ofType(TypeActionOutskirtsInfo.Received), action$.pipe(filter(function (action) {
        return action.type === TypeActionLoading.Complete &&
            action.bundleId === IdAssetBundleCore.Buildings;
    }))).pipe(delay(100), take(1), map(function () { return actionOutskirtsBundleLoad(selectOutskirtBuildingBundleOnLoad(state$.value)); }));
    var updateBundle$ = action$.ofType(TypeActionOutskirtsBundle.Load);
    var updateBundleBuffered$ = updateBundle$.pipe(
    // this buffers all calls for additional loading outskirt bundles until the initial loading has completed
    // TODO check if this is really necessary or if these calls can be discarded
    buffer(action$.pipe(filter(function (action) {
        return action.type === TypeActionLoading.Complete &&
            action.bundleId === IdAssetBundleCore.Outskirts;
    }))), take(1), switchMap(function (values) { return from(values); }));
    return concat(merge(initBundle$, updateBundleBuffered$), updateBundle$).pipe(switchMap(function (_a) {
        var bundle = _a.bundle;
        return utilLoader
            .load(IdAssetBundleCore.Outskirts, bundle)
            .pipe(map(createLoaderEventToActionMapper(IdAssetBundleCore.Outskirts)));
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/info/outskirts/epics/epicLoadOutskirtBuildings.ts
// module id = 1917
// module chunks = 3